import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { MDBModalRef } from "ng-uikit-pro-standard";
import { CognitoService } from "src/app/shared/services/cognito.service";
import { showError } from "src/app/shared/utils/functions/notification.function";
import Swal from "sweetalert2";

@Component({
  selector: "app-auth-modal",
  templateUrl: "./auth-modal.component.html",
  styleUrls: ["./auth-modal.component.scss"],
})
export class AuthModalComponent implements OnInit {
  mdbRef: MDBModalRef;

  tipoUsuario: string = "";

  formLogin: FormGroup;

  constructor(
    public modalRef: MDBModalRef,
    private cognitoService: CognitoService,
    private router: Router
  ) {}

  ngOnInit() {}

  login() {
    if (this.formLogin.valid) {
      this.cognitoService.signIn(this.email.value, this.senha.value).subscribe(
        (res) => {
          switch (res) {
            case "":
              this.close();
              this.router.navigate(["/home"]);
              break;
            case "newPassword":
              this.close();
              break;
            case "alertInvestidor":
              this.exibirAlertaInvestidor();
              break;
          }
        },
        (e) => {
          if (e.status == 400 || e.status == 422)
            return showError("", e.message);

          if (e.name == "PasswordResetRequiredException") {
            Swal.fire({
              text: e.message,
              showConfirmButton: true,
              showCloseButton: true,
              icon: "error",
            }).then((result) => {
              if (result.isConfirmed || result.isDismissed) {
                this.close();
              }
            });
          } else {
            showError("", e.message);
          }
        }
      );
    } else {
      if (this.senha.errors != null || this.senha.errors != undefined) {
        if (this.senha?.errors.strong || this.senha?.errors.minlength) {
          return showError(
            "",
            "Sua senha precisa ter no mínimo 8 caracteres, 1 letra maiúscula, 1 letra minúscula, 1 caractere especial e 1 número.."
          );
        }
      }

      return showError(
        "",
        `O campo ${this.email.value == "" ? "email" : "senha"} é obrigatório.`
      );
    }
  }

  cadastro() {
    this.modalRef.hide();
    return this.router.navigate(["/cadastro"]);
  }

  resetSenha() {
    this.modalRef.hide();
    return this.router.navigate(["/lost-password"]);
  }

  close() {
    return this.modalRef.hide();
  }

  //FORM
  private createFormLogin() {
    this.formLogin = new FormGroup({
      email: new FormControl("", [Validators.required]),
      senha: new FormControl("", [Validators.required]),
    });
  }

  //PRIVATE
  private createMenuItems(
    perfilUsuario: string,
    documentoIdentificador: string
  ) {
    let userActions: any[] = [];

    switch (perfilUsuario) {
      case "ENTIDADE": {
        userActions = [
          {
            urlPath: "/spg/home-ordinaria",
            nameItem: "Garantia Ordinária",
            icon: "fas fa-home icon",
          },
          {
            urlPath: "/spg/home-dpge",
            nameItem: "Garantia DPGE (Especial)",
            icon: "fas fa-home icon",
          },
          {
            urlPath: "/spg/historico-pagamento",
            nameItem: "Histórico Pagamentos",
            icon: "fas fa-file-invoice-dollar icon",
          },
          {
            urlPath: "/spg/perfil-investidor",
            nameItem: "Meu Perfil",
            icon: "fas fa-file-invoice-dollar icon",
          },
        ];
        break;
      }
      case "InvestidorFI".toUpperCase(): {
        userActions = [
          {
            urlPath: "/spg/home-ordinaria",
            nameItem: "Garantia Ordinária",
            icon: "fas fa-home icon",
          },
          {
            urlPath: "/spg/home-dpge",
            nameItem: "Garantia DPGE (Especial)",
            icon: "fas fa-home icon",
          },
          {
            urlPath: "/spg/historico-pagamento",
            nameItem: "Histórico Pagamentos",
            icon: "fas fa-file-invoice-dollar icon",
          },
          {
            urlPath: "/spg/perfil-investidor",
            nameItem: "Meu Perfil",
            icon: "fas fa-file-invoice-dollar icon",
          },
        ];
        break;
      }
      case "INVESTIDOR": {
        if (documentoIdentificador.length > 13) {
          userActions = [
            {
              urlPath: "/spg/home-ordinaria",
              nameItem: "Garantia Ordinária",
              icon: "fas fa-home icon",
            },
            {
              urlPath: "/spg/home-dpge",
              nameItem: "Garantia DPGE (Especial)",
              icon: "fas fa-home icon",
            },
            {
              urlPath: "/spg/historico-pagamento",
              nameItem: "Histórico Pagamentos",
              icon: "fas fa-file-invoice-dollar icon",
            },
            {
              urlPath: "/spg/perfil-investidor",
              nameItem: "Meu Perfil",
              icon: "fas fa-file-invoice-dollar icon",
            },
          ];
        } else {
          userActions = [
            {
              urlPath: "/spg/home-dpge",
              nameItem: "Garantia DPGE (Especial)",
              icon: "fas fa-home icon",
            },
            {
              urlPath: "/spg/perfil-investidor",
              nameItem: "Meu Perfil",
              icon: "fas fa-file-invoice-dollar icon",
            },
          ];
        }
        break;
      }

      default: {
        userActions = ["NO_ACCESS"];
        break;
      }
    }

    return userActions;
  }

  private exibirAlertaInvestidor() {
    Swal.fire({
      title: "Este canal é exclusivo para Pessoa Jurídica!",
      html:
        "<p>Se deseja solicitar ou consultar o status de sua garantia de Pessoa Física " +
        "Pessoa Física, utilize o aplicativo <b>FGC</b>.</p>" +
        'Caso as dúvidas persistam, encaminhe um e-mail para <a href="mailto:faleconosco@fgc.org.br">faleconosco@fgc.org.br</a>',
      icon: "error",
      confirmButtonText: "ok",
    });
  }

  private get email() {
    return this.formLogin.get("email");
  }

  private get senha() {
    return this.formLogin.get("senha");
  }
}
